import React from 'react';

const RecentActivitySkeleton = () => {
  return (
    <div className="space-y-6">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="flex items-start justify-between p-4 border-b border-silver-mist last:border-b-0">
          <div className="flex items-start space-x-4 flex-1">
            <div className="h-10 w-10 bg-silver-mist animate-pulse" style={{ borderRadius: '12px' }}></div>
            <div className="flex-1 space-y-3">
              <div className="h-4 bg-silver-mist animate-pulse w-full max-w-sm" style={{ borderRadius: '6px' }}></div>
              <div className="h-3 bg-silver-mist animate-pulse w-3/4 max-w-xs" style={{ borderRadius: '4px' }}></div>
            </div>
          </div>
          <div className="flex items-center space-x-3 ml-4">
            <div className="h-6 bg-silver-mist animate-pulse w-20" style={{ borderRadius: '6px' }}></div>
            <div className="h-8 bg-silver-mist animate-pulse w-16" style={{ borderRadius: '8px' }}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentActivitySkeleton;
